<template>
  <MainLayout>
  <div>
    <v-row align="center">
      <v-col cols="2">
        <CancelButton :project-id="projectId" />
      </v-col>
      <v-col cols="8">
        <h1 style="text-align: center; margin-bottom: 10px;">Edit KPI</h1>
      </v-col>
    </v-row>
    <KpiForm
        v-model="form"
        :project-id="projectId"
        :kpis-types="kpiTypes"
        :accumulated-weights="accumulatedWeights"
        :ignored-weights="ignoredWeights"
        @submit="submit"
        @save="saveAndExit"
        class="ma-12"
    ></KpiForm>
  </div>
  </MainLayout>
</template>

<script setup>
import MainLayout from '@/Layouts/Main.vue';
import KpiForm from './Form.vue';
import {onMounted, ref} from 'vue';
import * as $routes from '../../packs/routes'
import { router } from '@inertiajs/vue3';
import CancelButton from "@/Shared/CancelButton.vue";

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  },
  kpiId: {
    type: Number,
    required: true
  },
  kpi: {
    type: Object,
    required: true
  },
  kpiTypes: {
    type: Array,
    required: true
  },
  aggregationLevels: {
    type: Array,
    required: true
  },
  accumulatedWeights: {
    type: Object,
    required: false,
    default: null
  },
  ignoredWeights: {
    type: Array,
    required: false,
    default: function () {
      return []
    }
  }
})

let confirmCancel = ref(false);

const form = ref({
  kpi: props.kpi,
  aggregationLevels: fixAggregationLevels(props.aggregationLevels)
})

function fixAggregationLevels(levels) {

  for (let i = 0; i < levels.length; i++) {
    if (levels[i].text === 'Peb')
      levels[i].text = 'PEB';

    if (levels[i].text === 'Ped')
      levels[i].text = 'PED';
  }

  return levels;
}

const initialSectors = ref([])
const initialAggregationLevels = ref([])

function submit(){
  createFormObject(true, initialSectors.value)
  router.put($routes.project_kpi(props.projectId, props.kpiId), form.value)
}

function saveAndExit(){
  createFormObject(false)
  router.put($routes.project_kpi(props.projectId, props.kpiId), form.value)
}

function createFormObject(complete=true, initialSect){
  const sectors = form.value.kpi.sectors_attributes
  const levels = form.value.aggregationLevels
  const initialSectors = initialSect
  sectors.forEach(function(sector,index) {
    const dbIds = {}
    let destroyIds = {}
    // check if sector has aggregation levels that are being edited
    if (sector.aggregation_level_results_attributes) {
      sector.aggregation_level_results_attributes.forEach(function callbackFn(attr, index) {
        dbIds[attr.name] = attr.id
      })
    }
    // check if a new aggregation level has been added
    sector.aggregation_level_results_attributes = []
    const sectorKey = `sector_${sector.name}_weight`
    levels.forEach(function callbackFn(level, index) {
      const aggObj = {
        name: level.name,
        value: level.value,
        weight: level[sectorKey],
        sector_id: sector.id,
        dimension_id: null,
        id: dbIds[level.name]
      }
      sector.aggregation_level_results_attributes.push(aggObj)
    })

    // add notation for sectors that are destroyed
    initialSectors.forEach(function callbackFn(sector, index) {
      if (!sectors.find(s => s.name === sector.name)) {
        sectors.push({_destroy: true, id: sector.id, name: sector.name})
      }
    })
  })
    // new aggregation level array
    const initialLevels = initialAggregationLevels.value
    form.value.kpi.aggregation_levels_attributes = []
    const levelsAttrs = form.value.kpi.aggregation_levels_attributes
    levels.forEach(function (level, index){
      const existingObj = initialLevels.find(l => l.name === level.name)
      const id = existingObj ? existingObj.id : null
      const aggObj = {
        name: level.name,
        value: level.value,
        id: id
      }
      levelsAttrs.push(aggObj)
    })
    // add notation for aggregation levels to be destroyed
    initialLevels.forEach(function callbackFn(level, index) {
      if (!levels.find(s => s.name === level.name)) {
        levelsAttrs.push({ _destroy: true, id: level.id, name: level.name })
      }
    })

    const dimension = form.value.kpi.dimension_attributes
    const dbIds = {}
    dimension.aggregation_level_results_attributes.forEach(function callbackFn(attr, index) {
      dbIds[attr.name] = attr.id
    })
  dimension.aggregation_level_results_attributes = []
  levels.forEach(function callbackFn(level, index) {
    const aggObj = {
      name: level.name,
      value: level.value,
      weight: level.dimension_weight,
      sector_id: null,
      dimension_id: dimension.id,
      id: dbIds[level.name]
    }
    dimension.aggregation_level_results_attributes.push(aggObj)
  })

  form.value.kpi.state = complete
}

onMounted(()=>{
  const sectors = form.value.kpi.sectors_attributes
  for (let i = 0; i < sectors.length; i++) {
    const sector = sectors[i]
    initialSectors.value.push({ name: sector.name, id: sector.id })
  }

  const levels = form.value.aggregationLevels
  for (let i = 0; i < levels.length; i++) {
    const level = levels[i]
    initialAggregationLevels.value.push({ name: level.name, id: level.id })
  }
})

</script>

<style scoped>

</style>